import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RegretRoulette from './RegretRoulette';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RegretRoulette />} />
    </Routes>
  );
} 